/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1PaymentsTransaction } from './V1PaymentsTransaction'
import {
    V1PaymentsTransactionFromJSON,
    V1PaymentsTransactionFromJSONTyped,
    V1PaymentsTransactionToJSON,
    V1PaymentsTransactionToJSONTyped
} from './V1PaymentsTransaction'

/**
 *
 * @export
 * @interface V1PaymentsHistoryResponse
 */
export interface V1PaymentsHistoryResponse {
    /**
     *
     */
    items?: Array<V1PaymentsTransaction>
}

/**
 * Check if a given object implements the V1PaymentsHistoryResponse interface.
 */
export function instanceOfV1PaymentsHistoryResponse(
    value: object
): value is V1PaymentsHistoryResponse {
    return true
}

export function V1PaymentsHistoryResponseFromJSON(
    json: any
): V1PaymentsHistoryResponse {
    return V1PaymentsHistoryResponseFromJSONTyped(json, false)
}

export function V1PaymentsHistoryResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentsHistoryResponse {
    if (json == null) {
        return json
    }
    return {
        items:
            json['items'] == null
                ? undefined
                : (json['items'] as Array<any>).map(
                      V1PaymentsTransactionFromJSON
                  )
    }
}

export function V1PaymentsHistoryResponseToJSON(
    json: any
): V1PaymentsHistoryResponse {
    return V1PaymentsHistoryResponseToJSONTyped(json, false)
}

export function V1PaymentsHistoryResponseToJSONTyped(
    value?: V1PaymentsHistoryResponse | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items:
            value['items'] == null
                ? undefined
                : (value['items'] as Array<any>).map(
                      V1PaymentsTransactionToJSON
                  )
    }
}
